import Api from '../baseApi'

export default {
  async fetchAll() {
    return await Api.get(`/api-article/v1/article`);
  },
  async fetch(id) {
    return await Api.get(`/api-article/v1/article/${id}`);
  },
  async fetchAddition(id) {
    return await Api.get(`/api-article/article-addition/v1/${id}`);
  },
  async updateAddition(data) {
    return await Api.put(`/api-article/article-addition/v1/`, data);
  },
  async create(data) {
    return await Api.put('/api-article/v1/article', data);
  },
  async update(data) {
    return await Api.post('/api-article/v1/article', data);
  },
  async assignGroups(articleId, groups) {
    return await Api.post(`/api-article/v1/article/assign-groups/${articleId}`, groups);
  },
  async delete(id) {
    return await Api.delete(`/api-article/v1/article/${id}`);
  },
}
